import { colorsList } from "../data/colorsList";

export default function StdButton({
  onClick,
  label,
  color,
  width = "auto",
  style = {},
}) {
  return (
    <div
      className="buttons"
      style={{ backgroundColor: color ?? colorsList.blue, width, ...style }}
      onClick={onClick}
    >
      {label}
    </div>
  );
}
